import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "./firebase";

const repairListingsRef = collection(db, "repairListings");

export function subscribeToActiveRepairListings(callback) {
  const q = query(repairListingsRef, where("status", "==", "active"), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function subscribeToMyRepairListings(providerUserId, callback) {
  const q = query(repairListingsRef, where("providerUserId", "==", providerUserId), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function createRepairListing(providerUserId, data) {
  return addDoc(repairListingsRef, {
    ...data,
    providerUserId,
    status: "active",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export function updateRepairListing(listingId, data) {
  return updateDoc(doc(db, "repairListings", listingId), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export function pauseRepairListing(listingId) {
  return updateRepairListing(listingId, { status: "paused" });
}

export function reactivateRepairListing(listingId) {
  return updateRepairListing(listingId, { status: "active" });
}

export function deleteRepairListing(listingId) {
  return deleteDoc(doc(db, "repairListings", listingId));
}
